import { css } from '@emotion/react'
import { Flow, Text } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'

interface HistoricoMChatResultadoParcialTableItemProps {
  valor: boolean
}

export const HistoricoMChatResultadoParcialTableItem = (
  props: Readonly<HistoricoMChatResultadoParcialTableItemProps>
) => {
  const { valor } = props
  const { status } = styles(valor)

  return (
    <Flow direction='horizontal' gap={1} justifyItems='stretch' justifyContent='flex-end'>
      <Text heading={4} fontWeight='bold'>
        Resultado parcial:
      </Text>
      <Text heading={4} style={status}>
        {valor ? 'Passou' : 'Falhou'}
      </Text>
    </Flow>
  )
}

const styles = (passou: boolean) => ({
  status: css`
    color: ${passou ? green.c30 : red.c30};
    font-weight: bold;
  `,
})
